import { render, staticRenderFns } from "./Backlog.vue?vue&type=template&id=49bccacd&scoped=true"
import script from "./Backlog.vue?vue&type=script&lang=js"
export * from "./Backlog.vue?vue&type=script&lang=js"
import style0 from "./Backlog.vue?vue&type=style&index=0&id=49bccacd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bccacd",
  null
  
)

export default component.exports